import React from 'react';
import { ArrowRight } from 'lucide-react';

export const FocusStrip: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="w-full bg-[#EFECE6] border-y border-gray-200">
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <span className="block text-xs font-bold tracking-[0.2em] text-gray-500 uppercase mb-6">Current Priority</span>
        <h2 className="text-5xl md:text-6xl font-serif mb-8 text-primary leading-[1.1]">First Focus: Content Syndication</h2>
        <p className="max-w-3xl text-xl md:text-2xl text-secondary leading-relaxed font-light font-sans mb-10">
          The first release from LeadFraud.org will shed light on the dark side of content syndication leads - where intent, consent, and truth often drift apart.
        </p>
        <button 
          onClick={scrollToTop}
          className="group inline-flex items-center gap-3 text-primary text-lg font-medium border-b border-primary pb-0.5 hover:text-gray-600 hover:border-gray-600 transition-colors"
        >
          Get the first report when it’s out
          <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
        </button>
      </div>
    </div>
  );
};